<template>
	<span class="counter">
		{{ counter }}
	</span>
</template>

<script>
export default {
	props: {
		counter: {
			type: Number,
			default: null,
			required: true,
		},
	},
};
</script>
